'use client';

import { FC, ReactNode, useEffect, useState } from 'react';
import { I18nextProvider } from 'react-i18next';
import { i18n as i18nInterface } from 'i18next';
import initTranslations from '@/i18n';

interface ITranslationsProviderProps {
  children: ReactNode;
  namespaces: string[];
  locale: string;
  fallback?: ReactNode;
}

let i18n: i18nInterface;

const TranslationsProvider: FC<ITranslationsProviderProps> = ({children, namespaces, locale, fallback}) => {
  const [instance, setInstance] = useState<i18nInterface>(i18n);

  useEffect(() => {
    const init = async () => {
      if (!i18n) {
        const newInstance = await initTranslations(locale, namespaces);
        i18n = newInstance;
        setInstance(newInstance);
      } else if (i18n.language !== locale) {
        await i18n.changeLanguage(locale);
      }
    }

    init();
  }, [locale, namespaces]);

  if (!instance) {
		return fallback;
	}

  return (
    <I18nextProvider i18n={instance} defaultNS={namespaces[0]}>
      {children}
    </I18nextProvider>
  )
}

export default TranslationsProvider;